/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in/illustration";
import SignUp from "layouts/authentication/sign-up/illustration";

// @mui icons
import Icon from "@mui/material/Icon";
import Events from "./layouts/events";
import Settings from "./layouts/pages/account/settings";
import ProductPage from "./layouts/products/product-page";
import AllEvents from "./layouts/pages/events/all-events";
import EditEvent from "./layouts/pages/events/edit-events";
import NewEvent from "./layouts/pages/events/new-event";
import EventPage from "./layouts/pages/events/event-page";
import EventDetail from "./layouts/pages/events/event-detail";
import AllPhotos from "./layouts/pages/photo/all-photos";
import SearchList from "./layouts/pages/search/search-list";
import ResetPassword from "./layouts/authentication/reset-password/cover";
import {Privacy} from "./layouts/privacy/Privacy";
import {Kvkk} from "./layouts/privacy/Kvkk";

/* Access Type
    0 -> Just not log in
    1 -> Not log in
    2 -> Log in
    3 -> Subscribe
    4 -> Super user
*/
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    sidebar: {
      visible: true,
    },
    access_type: 1
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Settings />,
    sidebar: {
      visible: true
    },
    access_type: 1
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    sidebar: {
      visible: false,
    },
    access_type: 0
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
    sidebar: {
      visible: false,
    },
    access_type: 0
  },
  {
    type: "collapse",
    name: "Reset",
    key: "reset",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
    sidebar: {
      visible: false,
    },
    access_type: 0
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/events",
    component: <AllEvents />,
    sidebar: {
      visible: true,
    },
    access_type: 2
  },
  {
    type: "collapse",
    name: "EditEvent",
    key: "editEvent",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/events/edit/:id",
    component: <EditEvent />,
    sidebar: {
      visible: false,
    },
    access_type: 2
  },
  {
    type: "collapse",
    name: "NewEvent",
    key: "newEvent",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/events/new",
    component: <NewEvent />,
    sidebar: {
      visible: false,
    },
    access_type: 2
  },
  {
    type: "collapse",
    name: "EventDetail",
    key: "eventDetail",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/events/:id",
    component: <EventDetail />,
    sidebar: {
      visible: false,
    },
    access_type: 2
  },
  {
    type: "collapse",
    name: "AllPhotos",
    key: "allPhotos",
    icon: <Icon fontSize="small">photograph</Icon>,
    route: "/events/:id/gallery",
    component: <AllPhotos />,
    sidebar: {
      visible: false,
    },
    access_type: 2
  }
  ,
  {
    type: "collapse",
    name: "SearchList",
    key: "searchList",
    icon: <Icon fontSize="small">search</Icon>,
    route: "/searchList",
    component: <SearchList />,
    sidebar: {
      visible: true,
    },
    access_type: 2
  },
  {
    type: "privacy",
    name: "Privacy",
    key: "privacy",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/privacy",
    component: <Privacy />,
    sidebar: {
      visible: false,
    },
    access_type: 0
  },
  {
    type: "kvkk",
    name: "K.V.K.K",
    key: "kvkk",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/kvkk",
    component: <Kvkk />,
    sidebar: {
      visible: false,
    },
    access_type: 0
  },
];

export default routes;
